import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { useGetReleaseNotesQuery, useDeleteReleaseNoteMutation } from '../../../../../Redux/Api/ReleaseNote';
import Button from '../../../../Shared/Form/Button'
import Title from '../../../../Shared/Title'
import LoadingPage from '../../../LoadingPage'
import { Hydra } from '../../../../../Utils/Hydra'
import BusyArea from '../../../../Shared/BusyArea'
import { useMediaQuery } from '@mui/material';
import GenericDatagrid from '../../../../Datagrid/GenericDatagrid';
import RowActions, { RowAction } from '../../../../Datagrid/DatagridLayout/Rows/RowActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/pro-light-svg-icons';

const ReleaseNoteList = () => {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()

  const [busy, setBusy] = useState(false);

  const [deleteReleaseNote] = useDeleteReleaseNoteMutation()
  const { data: releaseNote, refetch } = useGetReleaseNotesQuery();

  const isSmallScreen = useMediaQuery('(min-width: 500px)');


  const deleteReleaseNoteAction = async (id: string) => {
    if (busy) return

    setBusy(true)

    try {
      await deleteReleaseNote(id)
      refetch();
    } catch (e) {
      let err = e as Hydra.Error
      console.error(err)
    }

    setBusy(false)
  }

  const getHighestVersion = () => {
    if (!releaseNote || releaseNote.length === 0) return '';
    const versions = releaseNote.map(note => note.version);
    versions.sort((a, b) => {
      const aParts = a.split('.').map(Number);
      const bParts = b.split('.').map(Number);

      for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
        const aVal = aParts[i] || 0;
        const bVal = bParts[i] || 0;
        if (aVal > bVal) return -1;
        if (aVal < bVal) return 1;
      }
      return 0;
    });
    return versions[0];
  }

  const columns = [
    {
      field: 'version',
      headerName: t('releasenote:version'),
      flex: 1,
    },
    {
      field: 'type',
      headerName: t('cards:list:type'),
      flex: 1,
      hide: !isSmallScreen,
    },
    {
      field: 'title',
      headerName: t('releasenote:title'),
      flex: 1,
    },
    {
      field: 'actions',
      headerName: '',
      width: 120,
      renderCell: (params: any) => {
        const actions: RowAction[] = [
          {
            label: t('cards:list:adjust'),
            icon: <FontAwesomeIcon icon={faEdit} />,
            onClick: () => navigate(`/${i18n.language}/dashboard/admin/notes/edit/` + params.row.id),
          },
          {
            label: t('cards:list:delete'),
            icon: <FontAwesomeIcon icon={faTrashAlt} />,
            withModal: {
              onYes: () => { deleteReleaseNoteAction(params.row.id); }
            }
          },
        ];

        return <RowActions actions={actions} />;
      },
    }
  ];

  if (!releaseNote) return <LoadingPage />

  return (
    <>
      <BusyArea busy={busy}>
        <div className='flex flex-col lg:flex-row justify-between items-start lg:items-center'>
          <Title text={t('releasenote:Releasenotes')} textNotBold />
          <Button
            action={() => navigate(`/${i18n.language}/dashboard/admin/notes/create#version=${getHighestVersion()}`)}
            className='my-6'
            title={t('releasenote:createReleasenote')}
            icon={faPlus}
            iconright
          />
        </div>

        <GenericDatagrid
          data={releaseNote}
          columns={columns}
          onRowClick={(params: any) => navigate(`/${i18n.language}/dashboard/admin/notes/edit/` + params.row.id)}
          className='mb-5 lg:mb-10'
        />
      </BusyArea>
    </>
  )
}

export default ReleaseNoteList
